import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { useAppContext } from '~/services/main/contexts/AppContext';

export const OrgAdminRedirect: FC = () => {
  const {
    isSelectedOrgAdmin,
    loadingIsSelectedOrgAdmin,
    loadingOrganizations,
  } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loadingIsSelectedOrgAdmin && !loadingOrganizations) {
      if (isSelectedOrgAdmin) {
        navigate('/organizations/compliance', { replace: true });
      } else {
        navigate('/map', { replace: true });
      }
    }
  }, [
    isSelectedOrgAdmin,
    loadingIsSelectedOrgAdmin,
    navigate,
    loadingOrganizations,
  ]);

  // Return null or a loading state while waiting for admin status
  return <CenterSpinner />;
};
